// extracted by mini-css-extract-plugin
export default {"activity":"activity_activity__QMU1t","label":"activity_label__S6rPv","toggle":"activity_toggle__6NUEX","input":"activity_input__YOEB9"};